// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7003":"81d3dbb4","9121":"efcf07ee"}[chunkId] + ".chunk.css";
};